"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = require("../styled");
const Icon = ({ variant, icon }) => {
    var _a;
    if (icon) {
        if (variant)
            console.warn('Notification: variant prop is being overridden by a customIcon prop');
        if (typeof icon === 'function')
            return (_a = icon()) !== null && _a !== void 0 ? _a : null;
        return icon;
    }
    switch (variant) {
        case 'error':
            return ((0, jsx_runtime_1.jsx)(styled_1.StyledIconContainer, { children: (0, jsx_runtime_1.jsx)(styled_1.StyledErrorIcon, {}) }));
        case 'success':
            return ((0, jsx_runtime_1.jsx)(styled_1.StyledIconContainer, { children: (0, jsx_runtime_1.jsx)(styled_1.StyledSuccessIcon, {}) }));
        case 'warning':
            return ((0, jsx_runtime_1.jsx)(styled_1.StyledIconContainer, { children: (0, jsx_runtime_1.jsx)(styled_1.StyledWarningIcon, {}) }));
        case 'information':
            return ((0, jsx_runtime_1.jsx)(styled_1.StyledIconContainer, { children: (0, jsx_runtime_1.jsx)(styled_1.StyledInformationIcon, {}) }));
        default:
            return null;
    }
};
exports.Icon = Icon;
